import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormRouteOptions } from "@form/cer-form-route-options";
import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormPanesSettingsUtil } from "@form/cer-form-panes/cer-form-panes.service";

export class CerFormViewFactoryAdapter {

  public static async formviewSetFromRouteOptions(routeOptions: CerFormRouteOptions): Promise<CerFormViewSet> {
    const adapter: CerFormAdapter = routeOptions?.routeAdapterType ? new routeOptions.routeAdapterType() : null;
    if (adapter == null || (await adapter.initFromRouteOptions(routeOptions)) !== true) {
      return null;
    }
    var viewSet: CerFormViewSet = null;
    if (adapter != null) {
      viewSet = new CerFormViewSet();
      viewSet.adapter = adapter;
      viewSet.routeOptions = adapter.routeOptions;
      adapter.viewSetInit(viewSet);
      viewSet.panes ??= CerFormPanesSettingsUtil.main();
    }
    return viewSet;
  }
}